import React from 'react';
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { useTranslation } from 'react-i18next';
import Trash from '../../../assets/icons/Trash.png';
import DarkTrash from '../../../assets/icons/Trash_black.png';
import { RiDeleteBin6Line } from "react-icons/ri";

const Card = ({ number, team1, team2, odd, choosen, handleRemoveCard, match, normalColor = true }) => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  const homeTeamName = i18n.language === 'en' ? team1 : match.homeTeamMyan;
  const awayTeamName = i18n.language === 'en' ? team2 : match.awayTeamMyan;

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const removeCard = () => {
    handleSongClick();
    handleRemoveCard(match.rapidEventId);
  }
  return (
    <div className="relative px-1 text-sm">
      <div className={`grid grid-cols-12 items-center border-[0.5px] border-dashed border-slate-400 dark:border-slate-700 py-2 transition-all`}
      >
        {/* No. */}
        <div className="col-span-1 text-center">
          <span className="text-slate-600 dark:text-slate-400">{number}.</span>
        </div>

        {/* Teams */}
        <div className="col-span-5 flex flex-col pl-1 border-l border-dashed border-slate-400 dark:border-slate-700">
          <h4 className={`${match.overId === match.homeId ? "text-orange-500" : "dark:text-gray-300 text-gray-700"}`}>
            {homeTeamName}
          </h4>
          <h4 className={`${match.overId === match.awayId ? "text-orange-500" : "dark:text-gray-300 text-gray-700"}`}>
            {awayTeamName}
          </h4>
        </div>

        {/* Odd */}
        <div className="col-span-1 flex justify-end items-center w-full h-full pr-1">
          <span className="text-xs text-center font-dangrek text-orange-500 bg-orange-100 dark:bg-yellow-500/10 rounded-md whitespace-nowrap w-full py-1">
            {odd}
          </span>
        </div>

        {/* Pick */}
        <div className="col-span-4 text-center border-x border-dashed border-slate-400 dark:border-slate-700">
          <span className="text-slate-800 dark:text-slate-100">
            {choosen === 'home' ? homeTeamName : choosen === 'away' ? awayTeamName : choosen === 'over' ? t("goalOver") : t("goalUnder")}
          </span>
        </div>

        {/* Delete */}
        <div className="col-span-1 flex justify-center">
          <button onClick={removeCard} className="text-slate-600 dark:text-slate-400 hover:text-red-500 transition-colors">
            <RiDeleteBin6Line size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
